import React from "react";
import logo from "../../assets/images/logo.png";
import Image from "./Image";
const LoadingFallback = () => {
  return (
    <div className="fixed inset-0 z-50 bg-white flex flex-col items-center justify-center px-6">
      <div className="w-80 mb-6 animate-pulse">
        <Image src={logo} alt="Dancebrite" />
      </div>
      <div className="relative w-64 h-2 bg-gray-200 rounded-full overflow-hidden">
        <div className="absolute h-full bg-gradient-to-r from-pink-500 to-purple-500 animate-loading-bar rounded-full" />
      </div>
      <div className="flex space-x-2 mt-5">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className={`w-3 h-3 rounded-full bg-gradient-to-br from-pink-500 to-purple-500 animate-bounce`}
            style={{ animationDelay: `${i * 0.2}s` }}
          />
        ))}
      </div>
    </div>
  );
};
export default LoadingFallback;
